import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface PanelGroupProps extends HTMLAttributes<HTMLDivElement> {
  /** When set, the group becomes a CSS grid with the given column count. */
  columns?: number;
  /** Gap in pixels between children.  Defaults to 12px (Phoenix `--phx-space-5`). */
  gap?: number;
  children: ReactNode;
}

/**
 * Wrapper that arranges Panels in a column or grid with a consistent gap.
 */
export function PanelGroup({
  columns,
  gap = 12,
  className,
  style,
  children,
  ...rest
}: PanelGroupProps) {
  const layoutStyle: CSSProperties = columns
    ? { display: 'grid', gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, gap }
    : { display: 'flex', flexDirection: 'column', gap };
  return (
    <div
      className={cn('phx-panel-group', className)}
      style={{ ...layoutStyle, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
